<main class="w-100 h-100">

  <!-- Hero Section - Login Panel (prototype) -->
  <section class="hero-section" id="home" [ngStyle]="{'height':!isLandingWithLogin ? '100vh' : ''}">
    <div class="container">
      <div class="login-card" id="myContainer">

        <!-- Logo -->
        <div class="logo-section">
          <div class="logo-circle">
            <img src="../../../assets/Img/fleetYar_logo_only.png" alt="">
          </div>
          <div class="brand-name">{{ webAppName }}<span></span></div>
          <div class="divider"></div>
          <div class="company-name">{{ appName }}</div>
        </div>

        <!-- Welcome -->
        <div class="welcome-section">
          <div class="welcome-title">به سامانه هوشمند ناوگان خوش آمدید</div>
          <div class="welcome-sub">مدیریت یکپارچه ناوگان</div>
        </div>

        <!-- Error (kept for prototype, actual errors via toast) -->
        <div class="error-message" id="errorMessage">
          <i class="fa fa-exclamation-circle"></i>
          <span id="errorText">خطا در ورود، لطفاً مجدداً تلاش کنید.</span>
        </div>

        <!-- Login Form - preserves all logic -->
        <form [formGroup]="LoginModel" (ngSubmit)="Login()" *ngIf="!otp">
          <div class="form-group">
            <div class="input-group">
              <span class="input-icon"><i class="fa fa-user"></i></span>
              <input type="text" formControlName="strUserName" name="strUserName" placeholder="نام کاربری یا شماره موبایل" autocomplete="off">
            </div>
          </div>

          <div class="form-group">
            <div class="input-group">
              <span class="input-icon"><i class="fa fa-lock"></i></span>
              <input [type]="password ? 'text' : 'password'" formControlName="strPassword" placeholder="رمز عبور" autocomplete="new-password">
              <button type="button" class="toggle-password" (click)="changeType()" tabindex="-1">
                <i class="fa" [ngClass]="password ? 'fa-eye-slash' : 'fa-eye'" ></i>
              </button>
            </div>
            <div class="forgot-row">
              <a class="forgot-link" tabindex="-1"  (click)="ForgetPass()">
                <i class="fa fa-key"></i> فراموشی رمز عبور؟
              </a>
            </div>
          </div>

          <div class="form-group">
            <div class="captcha-wrapper">
              <div class="captcha-input">
                <input type="text" formControlName="strCaptcha" #_captcha placeholder="کد امنیتی" [maxlength]="captcha.toString().length" (keypress)="numberOnly($event)" autocomplete="off">
              </div>
              <div class="captcha-box">
                <span class="captcha-code">{{captcha}}</span>
                <button type="button" class="captcha-refresh" (click)="get_Captcha()" tabindex="-1" >
                  <i class="fa fa-refresh"></i>
                </button>
              </div>
            </div>
          </div>

          <button type="submit" class="login-btn" (click)="Login()">
            <span class="btn-text">ورود به سامانه</span>
            <i class="fa fa-spinner fa-spin spinner"></i>
          </button>
        </form>

        <!-- Footer -->
        <div class="login-footer">
          <button class="help-btn" (click)="getLink(1)">
            <i class="fa fa-book"></i> راهنمای برنامه
          </button>
          <span class="app-version">نسخه {{version | faNum}}</span>
        </div>

      </div>
    </div>
  </section>

  <ng-container *ngIf="isLandingWithLogin">

    <!-- مدیریت ناوگان -->
    <section class="">
      <div class="py-5 d-flex flex-column justify-content-center align-items-center container">
        <div class="img-container text-center">
          <img width="128px" src="../../assets/Img/car-office.png" alt="مدیریت ناوگان">
        </div>
        <h1 class="fw-bold mt-3 text-center" style="font-size: 25px;line-height: 40px;">
          <p class="mb-1"> <strong> {{ webAppName }} </strong> </p>
          مدیریت ناوگان، تعمیر و نگهداری و سرویس های دوره ای خودرو و موتورسیکلت
        </h1>
        <div class="title-header w-100">
          <p class="m-0 text-muted text-center p-md-5" style="font-size:16px;line-height: 40px;">
            با {{webAppName}}، ناوگان خود را به‌صورت هوشمند مدیریت کنید! این نرم‌افزار با امکاناتی مانند اتوماسیون سفرهای اداری، برنامه‌ریزی سرویس‌های دوره‌ای، ردیابی وضعیت تانکرها و پایش مایعات داخل آن‌ها، به شما کمک می‌کند تا هزینه‌ها را کاهش دهید و بهره‌وری را افزایش دهید. نسخه وب و موبایل {{webAppName}}، مدیریت ناوگان را در هر زمان و هر مکان برای شما آسان می‌کند
          </p>
        </div>
      </div>
    </section>

    <!-- Training Section (prototype style with original data) -->
    <section class="training-section" id="training" #EducationContainer>
      <div class="container">
        <div class="section-title">
          <h2>محتوای آموزشی</h2>
          <p>ویدیوهای آموزشی مدیریت ناوگان و بهره‌وری حمل و نقل</p>
        </div>
        <div class="training-grid" *ngIf="lst_Educations.length > 0">
          <a *ngFor="let item of lst_Educations" class="training-card" (click)="openEducation(item)">
            <div class="video-thumb">
              <div class="video-container">
                <iframe class="responsive-iframe" [src]="item.strContentPath" allowFullScreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" style="position:absolute; top:0; left:0; width:100%; height:100%"></iframe>
              </div>
            </div>
            <div class="training-content">
              <h3>{{ subString_Title(item.strTitle,63) | faNum }}</h3>
              <p>{{ subString_Title(item.strDetail,130) | faNum}}</p>
              <span class="training-badge"><i class="fa fa-clock-o"></i> آموزش</span>
            </div>
          </a>
        </div>

        <div class="central" style="margin-top:20px">
          <button class="login-btn" style="max-width:200px; margin:0 auto" onclick="window.open('/educations','_blank')">مشاهده بیشتر</button>
        </div>
      </div>
    </section>

    <!-- News Section -->
    <section class="news-section" id="news" #EventContainer>
      <div class="container">
        <div class="section-title">
          <h2>آخرین اخبار</h2>
          <p>جدیدترین رویدادها و اطلاعیه‌های {{ webAppName }} </p>
        </div>
        <div class="news-grid" *ngIf="news.length > 0">
          <a *ngFor="let item of news" class="news-card" (click)="openNews(item?.iNews)">
            <img *ngIf="item.strImage" [src]="'data:image/png;base64,'+item.strImage" [alt]="item.strTitle" class="news-image">
            <img *ngIf="!item.strImage" src="../../../assets/imgs/preview__thumbnail.png" [alt]="item.strTitle" class="news-image">
            <div class="news-content">
              <div class="news-date"><i class="fa fa-calendar"></i> {{ item.strValidateDateAndTime | faNum }}</div>
              <h3>{{ subString_Title(item.strTitle,35) | faNum }}</h3>
              <p>{{ item.strTitle }}</p>
              <span class="news-read-more">مشاهده جزئیات <i class="fa fa-arrow-left"></i></span>
            </div>
          </a>
        </div>

        <div class="central" *ngIf="news.length > 0" style="margin-top:20px">
          <button class="login-btn" style="max-width:200px; margin:0 auto" onclick="window.open('/news','_blank')">مشاهده بیشتر</button>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="footer" id="about">
      <div class="container">
        <div class="footer-grid">
          <div>
            <h4>درباره {{ webAppName }} </h4>
            <p class="about-text">
              {{ webAppName }} راهکاری یکپارچه برای مدیریت ناوگان، سرویس‌های دوره‌ای، تعمیرات، سفرهای اداری، نظارت بر تانکرها و پایش مایعات. با {{webAppName}}، بهره‌وری را افزایش دهید و هزینه‌ها را کاهش دهید.
            </p>
          </div>
          <div>
            <h4>لینک‌های مفید</h4>
            <ul class="footer-links">
              <li><a href="#training"><i class="fa fa-chevron-left"></i> محتوای آموزشی</a></li>
              <li><a href="#news"><i class="fa fa-chevron-left"></i> آخرین اخبار</a></li>
              <li><a href="#"><i class="fa fa-chevron-left"></i> مدارک الکترونیک</a></li>
              <li><a href="#"><i class="fa fa-chevron-left"></i> راهنمای کاربری</a></li>
              <li><a (click)="getLink(1)" style="cursor:pointer"><i class="fa fa-chevron-left"></i> پشتیبانی</a></li>
            </ul>
          </div>
          <div id="contact">
            <h4>راه‌های ارتباطی</h4>
            <div class="contact-info">
              <p><i class="fa fa-envelope"></i> {{obj_Social?.strEmail || 'rayanandisheh@yahoo.com'}}</p>
              <p><i class="fa fa-phone"></i> {{ '021-77273160-2' | faNum }}</p>
              <p><i class="fa fa-map-marker"></i> {{ 'تهران، نارمک، بزرگراه شهید سلیمانی، بعد از چهارراه سرسبز، پلاک ۶۴۰، واحد ۸' | faNum }}</p>
            </div>
          </div>
          <div>
            <h4>دانلود اپلیکیشن</h4>
            <div class="app-download">
              <a href="https://cafebazaar.ir/app/com.rayanandisheh.radyab" target="_blank">
                <i class="fa fa-shopping-bag"></i> کافه بازار
              </a>
              <a href="#" target="_blank">
                <i class="fa fa-android"></i> گوگل پلی
              </a>
            </div>

          </div>
        </div>
        <div class="footer-bottom">
          &copy; {{ '1405' | faNum }} <span>{{ webAppName }} </span> - تمامی حقوق محفوظ است. | طراحی و توسعه توسط <span>رایان اندیشه نصر</span>
        </div>
      </div>
    </footer>

    <button class="scroll-top" id="scrollTop" onclick="window.scrollTo({top:0, behavior:'smooth'})">
      <i class="fa fa-chevron-up"></i>
    </button>

  </ng-container>

</main>
